module.exports = __webpack_public_path__ + "images/feature/smart_notification-dd362fe27d2f43f21cf2b001b2c394d6.jpg";